import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Engaging activities for seniors to enhance their quality of life" 
          className="hero-image" 
        />
        <p className="eyebrow">My Senior Activities</p>
        <h1>Empowering Seniors Through Engaging Activities</h1>
        <p className="lede">
          Discover a world of enriching experiences designed to enhance the quality of life for seniors. 
          Join us in creating joyful moments and lasting memories.
        </p>
        <div className="cta-row">
          <a href="/activities" target="_self">
            Explore Activities
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Discover New Hobbies</h2>
          <p>
            From arts and crafts to gardening, we offer a variety of activities that inspire creativity and joy.
          </p>
        </article>
        <article>
          <h2>Stay Active and Healthy</h2>
          <p>
            Engage in physical activities tailored for seniors to promote health and well-being in a fun way.
          </p>
        </article>
        <article>
          <h2>Connect with Others</h2>
          <p>
            Join our community events to meet new friends and share experiences in a supportive environment.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;